import React from 'react';
import { TsrTooltip } from 'tacho-ui';
interface TachoTooltipProps {
    id: string;
    content: string | JSX.Element;
    maxWidth?: string;
    className?: string;
}

export function TachoTooltip(props: React.PropsWithChildren<TachoTooltipProps>): JSX.Element {
    return (
        <TsrTooltip maxWidth={props.maxWidth} className={props.className} content={props.content}>
            {props.children as any}
        </TsrTooltip>
    );
}
